import { render, staticRenderFns } from "./EmployeeWind.vue?vue&type=template&id=68a4ad16&"
import script from "./EmployeeWind.vue?vue&type=script&lang=js&"
export * from "./EmployeeWind.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWind.vue?vue&type=style&index=0&id=68a4ad16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports